// Loading js
// --- 遅延なしで読み込む処理（ローディング画面、FVに関する処理）をインポート

document.addEventListener('DOMContentLoaded', function() {
	if (document.querySelector('.js-load')) {
		document.querySelectorAll('.js-load').forEach(elm => {
			elm.classList.add('is-loaded');
		})
	}
});